// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  background-color: #110133;
  height: 100vh;
}

.login-form {
  max-width: 400px;
  margin: 3rem auto 0 !important;
  font-weight: 400;
}

.btn-login {
  background-color: #11BC97;
  font-size: 16px;
  border: 0;
  border-radius: 2px;
  padding: 8px 16px;
  color: #ffffff;
  width: 100%;
  font-family: "Roboto", sans-serif;
}

.btn-login:disabled, .btn-reset:disabled {
  background-color: #a7b2cd;
}

.login .form-control {
  background: transparent !important;
  color: #ffffff !important;
  border-radius: 2px !important;
  height: 40px !important;
}

.custom-control-label::before, .custom-control-label::after {
  background-color: transparent !important;
  top: 0.15rem !important;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #E66A8B;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #ffffff;
  background-color: #E66A8B;
}

.any-query {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  cursor: pointer;
}

.login-brand img {
  width: 345px;
}

.underline-hover:hover {
  text-decoration: underline !important;
}

.login .form-control::placeholder {
  color: rgba(255, 255, 255, 0.8) !important;
  opacity: 0.8 !important;
}

.btn-reset {
  background-color: #11BC97;
  font-size: 16px;
  border: 0;
  border-radius: 2px;
  padding: 8px 16px;
  color: #ffffff;
  width: 100%;
  font-family: "Roboto", sans-serif;
}

.center {
  text-align: center;
}

.login-link {
  background-color: #11BC97;
  font-size: 16px;
  border: 0;
  border-radius: 2px;
  padding: 8px 16px;
  color: #ffffff;
  width: 100%;
  font-family: "Roboto", sans-serif;
  text-align: center;
  display: block;
  color: #fff !important;
}

.width-100pc {
  width: 100%;
}

.margin-bottom-40 {
  margin-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./src/styles/loginPage.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,yBCSc;EDRf,aAAA;AADD;;AAGA;EACE,gBAAA;EACA,8BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,yBCXW;EDYX,eAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,cClBY;EDmBZ,WAAA;EACA,iCAAA;AAAF;;AAGA;EACC,yBCPiB;ADOlB;;AAGA;EACE,kCAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;AAAF;;AAEA;EACE,wCAAA;EACA,uBAAA;AACF;;AACA;EACE,yBChCU;ADkCZ;;AAAA;EACE,cCzCY;ED0CZ,yBCpCU;ADuCZ;;AADA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAIF;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,qCAAA;AAKF;;AADA;EACE,0CAAA;EACA,uBAAA;AAIF;;AADA;EACE,yBC/DW;EDgEX,eAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,cCtEY;EDuEZ,WAAA;EACA,iCAAA;AAIF;;AAAA;EACE,kBAAA;AAGF;;AAAA;EACE,yBC/EW;EDgFX,eAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,cCtFY;EDuFZ,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AAGF;;AAAA;EACE,WAAA;AAGF;;AAAA;EACE,mBAAA;AAGF","sourcesContent":["@import './colors';\n\n.login{\n  background-color: $color-darkBlue;\n\theight: 100vh;\n}\n.login-form {\n  max-width: 400px;\n  margin: 3rem auto 0 !important;\n  font-weight:400;\n}\n\n.btn-login {\n  background-color: $color-green;\n  font-size: 16px;\n  border: 0;\n  border-radius: 2px;\n  padding: 8px 16px;\n  color: $color-white;\n  width: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.btn-login:disabled, .btn-reset:disabled {\n background-color: $color-light-blue; \n}\n\n.login .form-control {\n  background: transparent !important;\n  color: $color-white !important;\n  border-radius: 2px !important;\n  height: 40px !important;\n}\n.custom-control-label::before, .custom-control-label::after{\n  background-color: transparent !important;\n  top: 0.15rem !important;\n}\n.custom-checkbox .custom-control-input:checked~.custom-control-label::before {\n  background-color: $color-pink;\n}\n.custom-control-input:checked~.custom-control-label::before {\n  color: $color-white;\n  background-color: $color-pink;\n}\n.any-query{\n  position: fixed;\n  bottom: 1rem;\n  right: 1rem;\n  cursor: pointer;\n}\n.login-brand img {\n  width: 345px;\n}\n\n.underline-hover:hover {\n  text-decoration: underline !important;\n}\n\n\n.login .form-control::placeholder {\n  color: rgba(255, 255, 255, 0.8) !important;\n  opacity: 0.8 !important;\n}\n\n.btn-reset {\n  background-color: $color-green;\n  font-size: 16px;\n  border: 0;\n  border-radius: 2px;\n  padding: 8px 16px;\n  color: $color-white;\n  width: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n\n.center{\n  text-align: center;\n}\n\n.login-link{\n  background-color: $color-green;\n  font-size: 16px;\n  border: 0;\n  border-radius: 2px;\n  padding: 8px 16px;\n  color: $color-white;\n  width: 100%;\n  font-family: 'Roboto', sans-serif;\n  text-align: center;\n  display: block;\n  color: #fff !important;\n}\n\n.width-100pc{\n  width: 100%;\n}\n\n.margin-bottom-40{\n  margin-bottom: 40px;\n}","$color-white: #ffffff;\n$color-black: #000000;\n$color-green:#11BC97;\n$color-secGreen:#0ead8a;\n$color-blue:#2091E9;\n$color-sharpGreen:#01FFCA;\n$color-pink:#E66A8B;\n$color-orange:#FB8C3D;\n$color-orange-high:#F4B717;\n$color-yellow:#FB8C3D;\n$color-purple:#A001FF;\n$color-light-purple:#7879F1;\n$color-darkBlue:#110133;\n$color-lightGrey:#F4F6FA;\n$color-normalGrey:#E4E7F0;\n$color-monoDullGrey:#A7B2CD;\n$color-monoNormalGrey:#636A7D;\n$color-light-blue:#a7b2cd;\n$color-monoIntenseGrey:#222735;\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
